/** Api methods */
import * as AdminApi from './api/admin'
import * as AnalyticsApi from './api/analytics'
import * as AuthApi from './api/auth'
import * as CartographyApi from './api/cartography'
import * as FilterApi from './api/filter'
import * as HealthApi from './api/health'
import * as NodeApi from './api/node'
import * as PlanLimitsApi from './api/plan-limits'
import * as RelationshipApi from './api/relationship'
import * as SettingsApi from './api/settings'
import * as TypeApi from './api/type'
import * as UserApi from './api/user'
import * as WorkspaceApi from './api/workspace'

export const ApiCaller = {
	...AdminApi,
	...AnalyticsApi,
	...AuthApi,
	...HealthApi,
	...UserApi,
	...NodeApi,
	...PlanLimitsApi,
	...RelationshipApi,
	...WorkspaceApi,
	...CartographyApi,
	...FilterApi,
	...SettingsApi,
	...TypeApi
}
